import { Message, sendMessage } from './Communication';
import { Brakesman, writeFile, ChunkSize } from './Filesystem/Helper';
import { remove } from './Filesystem/Wrapper';

// Submodules
import { getContent } from '../utils/Download';
import { ignoreAllRejects } from '../utils/Error';

import utils = egr.wcf.utils;

interface ShareEventOrigin {
    x: number;
    y: number;
}

interface DeprecatedShareArguments {
    content: string;
    mimetype: string;
    filename: string;
    save: boolean;
    pickPath: boolean;
    origin?: ShareEventOrigin;
    remove_path_after_share?: boolean;
}

/**
 * @deprecated
 * @param content base64 encoded content
 * @param mimetype
 * @param filename
 * @param save
 * flag which determines if the file should be save instantly (without user input - value true) or
 * if the user can choose which app should be used (value false or missing argument)
 * @param pickPath
 * flag which determines if the user should choose the path where the file should be
 * saved (value true (and `save` value true)) or not (value false or missing argument (or `save` value false))
 */
export async function shareContent(
    content: string | ArrayBuffer,
    mimetype: string,
    filename: string,
    save: boolean,
    pickPath: boolean,
    origin?: ShareEventOrigin,
    brakesman?: Brakesman
): Promise<void> {
    // Note: send big files in little chunks in order to save memory
    if (content instanceof ArrayBuffer && content.byteLength > ChunkSize) {
        const path: string = `/tmp/share/${filename.toLocaleLowerCase()}`;
        try {
            await writeFile(path, content, brakesman);
            await sharePath(path, mimetype, filename, save, pickPath, origin, true);
        } catch {
            remove(path).catch(ignoreAllRejects);
        }
        return;
    }

    return sendMessage<Message<DeprecatedShareArguments>>({
        type: 'share',
        action: 'decode',
        arguments: {
            content: content instanceof ArrayBuffer ? utils.arraybuffer.toBase64(content) : content,
            mimetype: mimetype,
            filename: filename,
            save: save,
            pickPath: pickPath,
            origin
          }
    });
}

/**
 * @deprecated
 * @param mimetype
 * @param filename
 * @param save
 * @param pickPath
 * @param origin
 * @param removePathAfterShare
 */
function sharePath(
    path: string,
    mimetype: string,
    filename: string,
    save: boolean,
    pickPath: boolean,
    origin?: ShareEventOrigin,
    removePathAfterShare: boolean = false
): Promise<void> {
    return sendMessage<Message<DeprecatedShareArguments>>({
        type: 'share',
        action: 'path',
        arguments: {
            content: path,
            mimetype,
            filename,
            save,
            pickPath,
            origin,
            remove_path_after_share: removePathAfterShare
          }
    });
}

/**
 * @deprecated
 * @param url
 * @param mimetype
 * @param filename
 * @param save
 * flag which determines if the file should be save instantly (without user input - value true) or
 * if the user can choose which app should be used (value false or missing argument)
 * @param pickPath
 * flag which determines if the user should choose the path where the file should be
 * saved (value true (and `save` value true)) or not (value false or missing argument (or `save` value false))
 */
export async function shareUrl(
    url: string,
    mimetype: string,
    filename: string,
    save: boolean,
    pickPath: boolean,
    origin?: ShareEventOrigin
): Promise<void> {
    if (url.startsWith('blob:')) {
        const data: ArrayBuffer = await getContent(url);
        return shareContent(
            data,
            mimetype,
            filename,
            save,
            pickPath,
            origin
        );
    }

    return sendMessage<Message<DeprecatedShareArguments>>({
        type: 'share',
        action: 'fetch',
        arguments: {
            content: url,
            mimetype: mimetype,
            filename: filename,
            save: save,
            pickPath: pickPath,
            origin
          }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/Share.ts